import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import ConditionalRoute from "./ConditionalRoute";

const mapStateToProps = (state, ownProps) => ({
  isAuthenticated: state.auth.isAuthenticated,
});

const PrivateRoute = ({ children, isAuthenticated, ...rest }) => {
  const conditions = [
    {
      test: () => isAuthenticated,
      redirectTo: "/login",
    },
  ];
  return (
    <ConditionalRoute {...rest} conditions={conditions}>
      {children}
    </ConditionalRoute>
  );
};

export default withRouter(connect(mapStateToProps)(PrivateRoute));
